import { Box } from '@material-ui/core';

export const CardPaymentProviderLogos = () => {
  const logoVisa = '/assets/providers_logo/logo-visa.svg';
  const logoMastercard = '/assets/providers_logo/logo-mastercard.svg';

  return (
    <Box display={'flex'} flexDirection={'row'} gridGap={4} alignItems={'center'}>
      <img src={logoVisa} style={{ width: `${26}px`, height: 'auto' }} />
      <img src={logoMastercard} style={{ width: `${26}px`, height: 'auto' }} />
    </Box>
  );
};
